import { Component } from 'react'
import PropTypes from 'prop-types'

class EveServerManager extends Component {
    constructor(props) {
        super(props)

        window.addServers = this.addServers
        window.updateEnabledServers = this.updateEnabledServers
    }

    shouldComponentUpdate() {
        return false
    }

    // Generate a server object to allow us to easily access information
    generateServerObject = (server) => {
        let url // The sso url
        let slinger // The sso token service slinger
        let websiteUrl = `https://launcher.${this.props.serviceDomains.testing}`

        // Handle unique cases (TQ and multi), as their SSO paths do not
        // conform to the other servers.
        switch (server.name) {
            case 'tq':
                url = `login.${this.props.serviceDomains.production}`
                slinger = this.props.tokenServices.production
                websiteUrl = `https://launcher.${this.props.serviceDomains.production}`
                break
            case 'mp':
                url = `multilogin.${this.props.serviceDomains.testing}`
                slinger = this.props.tokenServices.testing.replace('{server}', 'multi')
                break
            case 'galaxy':
            case 'serenity':
                url = `login.${this.props.serviceDomains.production}`
                slinger = this.props.tokenServices.testing.replace('{server}', server.name)
                break
            default:
                url = `${server.name}login.${this.props.serviceDomains.testing}`
                slinger = this.props.tokenServices.testing.replace('{server}', server.name)
                break
        }

        return {
            name: server.displayName,
            serverId: server.name,
            enabled: true,
            websiteUrl,
            sso: { url, slinger },
            status: 'offline',
        }
    }

    // Exposed function that replaces the server list
    // Example input:
    //   [{ name: 'tq', displayName: 'Tranquility' },
    //   { name: 'sisi', displayName: 'Singularity' },
    //   { name: 'duality', displayName: 'Duality' }]
    addServers = (servers) => {
        if (servers == null) return

        try {
            // Run through the json object of servers
            // and reformat it to what we are after
            const serverList = servers.reduce((sList, server) => {
                sList[server.name] = this.generateServerObject(server)
                return sList
            }, {})

            // Replace the server list in store
            this.props.setServers(serverList)
        } catch (error) {
            console.info(`Encountered error while running addServers: ${error.message}`, error)
        }
    }

    // Exposed function that sets what servers are enabled
    // Example input:
    //   ['tq', 'sisi', 'duality']
    updateEnabledServers = (enabledServerIds) => {
        try {
            // Update what servers are enabled
            this.props.setEnabledServers(enabledServerIds)
        } catch (error) {
            console.info(`Encountered error while running updateEnabledServers: ${error.message}`)
        }
    }

    render() {
        return null
    }
}

EveServerManager.propTypes = {
    serviceDomains: PropTypes.shape({
        testing: PropTypes.string,
        production: PropTypes.string,
    }),
    tokenServices: PropTypes.shape({
        testing: PropTypes.string,
        production: PropTypes.string,
    }),
    setEnabledServers: PropTypes.func,
    setServers: PropTypes.func,
}

export default EveServerManager



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/components/EveServerManager/component.js